var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNote = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 0.666504H2.00008C1.64646 0.666504 1.30732 0.806984 1.05727 1.05703C0.807218 1.30708 0.666748 1.64622 0.666748 1.99984V9.9998C0.666748 10.3535 0.807218 10.6926 1.05727 10.9426C1.30732 11.1927 1.64646 11.3332 2.00008 11.3332H10.0001C10.3537 11.3332 10.6928 11.1927 10.9429 10.9426C11.1929 10.6926 11.3334 10.3535 11.3334 9.9998V5.33317M6.66675 0.666504L11.3334 5.33317M6.66675 0.666504V5.33317H11.3334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/note.62523f61.svg";
export { ForwardRef as ReactComponent };